export enum ProspectStateEnum {
  Uncontacted = 1,
  Uninterested = 2,
  Interested = 3
}
